import { getApiUri } from '@carlito/config';
import { createFetcher } from '@carlito/network-utils';

const BASE_URL = getApiUri('fusionar');

const useFetchRequest = createFetcher(BASE_URL);

export default useFetchRequest;
